module.exports = __webpack_public_path__ + "static/media/booking.5298d9c7.png";